import axios from "axios";

const RESPONDENT_DASHBOARD_SERVICE = process.env.REACT_APP_RESPONDENT_DASHBOARD_MICROSERVICE_URL + process.env.REACT_APP_SERVICES_VERSION;

export default function RespondentDashboardService() {
}

/**
 * getOrganisationSurveyStatus
 * @param {long, long} 
 * @returns {map}
 */
export async function getOrganisationSurveyStatus(orgId, surveyCycleId) {

    const url = RESPONDENT_DASHBOARD_SERVICE + `/respondentdashboardservice/surveystatus/organisation/${orgId}/surveycycle/${surveyCycleId}`;
    const organisationStatus = axios.create({ baseURL: url });
    let internationalSourcesOfFundsData = [];

    await organisationStatus.get('')
        .then(response => {
            const data = response.data;
            if (data.status === "SUCCESS") {
                data.response.success.forEach(record => {
                    internationalSourcesOfFundsData.push(record);
                });
            }
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });

    return internationalSourcesOfFundsData;
}

/**
* getOrganisationInternationalSourcesofFunds
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationInternationalSourcesofFunds(orgId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/internationalsourcesoffunds/organisation/' + orgId +'/surveycycle/' + surveyCycleId;
    const sourcesOfFunds = axios.create({ baseURL: url });

    const internationalSourcesOfFunds = await sourcesOfFunds.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (internationalSourcesOfFunds !== undefined && internationalSourcesOfFunds !== null) {
        return internationalSourcesOfFunds;
    }

    return null;
}

/**
* getOrganisationCapitalExpenditure
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationCapitalExpenditure(organisationId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/capitalexpenditures/organisation/' + organisationId +'/surveycycle/' + surveyCycleId;
    const capitalExpenditureURL = axios.create({ baseURL: url });

    const capitalExpenditure = await capitalExpenditureURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (capitalExpenditure !== undefined && capitalExpenditure !== null) {
        return capitalExpenditure;
    }

    return null;
}

/**
* getOrganisationProvincialExpenditure
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationProvincialExpenditure(organisationId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/provincialexpenditures/organisation/' + organisationId +'/surveycycle/' + surveyCycleId;
    const provincialExpenditureURL = axios.create({ baseURL: url });

    const provincialExpenditure = await provincialExpenditureURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (provincialExpenditure !== undefined && provincialExpenditure !== null) {
        return provincialExpenditure;
    }

    return null;
}

/**
* getOrganisationCategoriesOfExpenditure
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationCategoriesOfExpenditure(organisationId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/categoriesofrndexpenditures/organisation/' + organisationId +'/surveycycle/' + surveyCycleId;
    const categoriesOfExpenditureURL = axios.create({ baseURL: url });

    const categoriesOfExpenditure = await categoriesOfExpenditureURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (categoriesOfExpenditure !== undefined && categoriesOfExpenditure !== null) {
        return categoriesOfExpenditure;
    }

    return null;
}

/**
* getOrganisationHeadCounts
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationHeadCounts(organisationId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/headcounts/organisation/' + organisationId + '/surveycycle/' + surveyCycleId;
    const headCountsURL = axios.create({ baseURL: url });

    const headCounts = await headCountsURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (headCounts !== undefined && headCounts !== null) {
        return headCounts;
    }

    return null;
}

/**
* getQuestionFactsByOrganisationIdAndSurveyCycleAndQuestionId
* @param {long, long} 
* @returns {map}
*/
export async function getQuestionFactsByOrganisationIdAndSurveyCycleAndQuestionId(organisationId, surveyCycleId, questionId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/questionfacts/organisation/' + organisationId + '/surveycycle/' + surveyCycleId + '/question/' + questionId;
    const headCountsURL = axios.create({ baseURL: url });

    const headCounts = await headCountsURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (headCounts !== undefined && headCounts !== null) {
        return headCounts;
    }

    return null;
}

/**
* getOrganisationFTECounts
* @param {long, long} 
* @returns {map}
*/
export async function getOrganisationFTECounts(organisationId, surveyCycleId) {
    const url = RESPONDENT_DASHBOARD_SERVICE + '/respondentdashboardservice/fulltimeequivalents/organisation/' + organisationId +'/surveycycle/' + surveyCycleId;
    const fteCountsURL = axios.create({ baseURL: url });

    const fteCounts = await fteCountsURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });
    
    if (fteCounts !== undefined && fteCounts !== null) {
        return fteCounts;
    }

    return null;
}